import { baseApi } from './baseApi';

export interface ISsoConnection {
    display_name: string;
    uuid: string;
}

export interface IEnterpriseConfig {
    resource_hostname_prefix_aliases: string[];
    sso_connections: ISsoConnection[];
}

const enterpriseConfigApi = baseApi.injectEndpoints({
    overrideExisting: false,
    endpoints: (build) => ({
        getEnterpriseConfig: build.query<IEnterpriseConfig, void>({
            query: () => ({
                url: '/system/enterprise/config/',
            }),
        }),
    }),
});

export const { useGetEnterpriseConfigQuery } = enterpriseConfigApi;
